import { ReactNode } from 'react';

import { Input } from 'libs/ui';
import { OrderSection as BaseOrderSection } from 'modules/account/orderModule/common/components';

export interface SectionProps {
  title: string;
  titleHint?: {
    title: ReactNode;
  };
  fields: {
    label: string;
    value: string | number | undefined | null;
    disabled?: boolean;
  }[];

  afterContent?: ReactNode;
  afterFields?: ReactNode;
}

export const OrderSection = ({
  title,
  titleHint,
  afterContent,
  afterFields,
  fields,
}: SectionProps) => (
  <BaseOrderSection
    afterContent={afterContent}
    afterFields={afterFields}
    fields={fields.map(({ label, value, disabled }) => (
      <Input
        fullWidth
        readOnly
        disabled={disabled}
        label={label}
        value={value}
      />
    ))}
    title={title}
    titleHint={titleHint}
  />
);
